import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PatientTabs from '../../../Components/ProviderComponents/Patients/PatientTabs';
import ProviderRouteAccess from './ProviderRouteAccess';
import PatientDetailsSidebar from '../../../Components/ProviderComponents/PatientDetailsSidebar/PatientDetailsSidebar';
import { useMediaQuery } from '@mui/material';
import PatientDetails from '../../../Components/ProviderComponents/Patients/PatientDetails';
import AllBookedAppointments from '../../../Components/PatientComponents/BookAppointment/AllBookedAppointments';
import UpdatePatientDocumentsDialog from '../../../Components/PatientComponents/PatientDashboard/UpdatePatientDocumentsDialog';
import UpdateLabReports from '../../../Components/PatientComponents/PatientDashboard/UpdateLabReports';
import UpdateAllergiesDialog from '../../../Components/PatientComponents/PatientDashboard/UpdateAllergiesDialog';
import AppointmentDetails from '../../../Components/ProviderComponents/AppointmentDetails/AppointmentDetails';
import Exercises from '../../../Components/PatientComponents/Exercises/Exercises';
import AvailableMemberships from '../../../Components/PatientMembership/AvailableMemberships';
import PatientMembershipDetails from '../../../Components/PatientMembership/PatientMembershipDetails';


const PatientViewProviderRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  return (
    <div>
      <PatientDetailsSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>
      <PatientTabs/>
        <Routes>
          <Route path="/PatientDetails/:uuid/:pid" element={<ProviderRouteAccess element={<PatientDetails />} />}/>
          <Route path="/patient-list" element={<ProviderRouteAccess element={<PatientTabs />} />}/>
          <Route path="/appointments/:uuid/:pid" element={<ProviderRouteAccess element={<AllBookedAppointments />} />}/>
          {/* <Route path="/all-appointments/:uuid/:pid" element={<ProviderRouteAccess element={<AllBookedAppointments />} />}/> */}
          <Route path="/documents/:uuid/:pid" element={<ProviderRouteAccess element={<UpdatePatientDocumentsDialog />} />}/>
          <Route path="/lab-reports/:uuid/:pid" element={<ProviderRouteAccess element={<UpdateLabReports />} />}/>
          <Route path="/allergies/:uuid/:pid" element={<ProviderRouteAccess element={<UpdateAllergiesDialog />} />}/>
          <Route path="/appointment/:uuid/:pid/:eid" element={<ProviderRouteAccess element={<AppointmentDetails />} />}/>
          <Route path="/exercises/:uuid/:pid" element={<ProviderRouteAccess element={<Exercises />} />}/>
          <Route path="/available-membership/:uuid/:pid" element={<ProviderRouteAccess element={<AvailableMemberships />} />}/>
          <Route path="/membership-details/:uuid/:pid/:groupId/:category/:plan_id" element={<ProviderRouteAccess element={<PatientMembershipDetails />} />}/>
        </Routes>
      </div>
    </div>
  );
};

export default PatientViewProviderRoutes;